// extracted by mini-css-extract-plugin
module.exports = {"container":"_1003609f","spinner":"_1b00e3c5","text":"_1c86e1c5"};